import React from 'react';
import { MsFormulaire, OperationMS } from '../types';
import OperationAcheteurRecap from './OperationAcheteurRecap';
import OperationFormulaireAdmin from './OperationFormulaireAdmin';
import OperationParticularites from './OperationParticularites';

interface OperationDescriptifAdministratifProps {
  operation: OperationMS;
  formData: MsFormulaire;
  viewMode: boolean;
  errors?: Record<string, string>;
  setFormData?: (data: MsFormulaire) => void;
}

// Descriptif administratif (refonte PDF) — 3 sous-blocs :
//  - Acheteur : recap LECTURE SEULE de l'organisme (hors payload, hors validation).
//  - Operation : champs editables (OperationFormulaireAdmin enrichi : type de commande, pays,
//    contact maitrise d'oeuvre, phases...).
//  - Particularites administratives : champs editables obligatoires.
const OperationDescriptifAdministratif: React.FC<OperationDescriptifAdministratifProps> = ({
  operation,
  formData,
  viewMode,
  errors = {},
  setFormData,
}) => (
  <div className="opms__descriptif-admin">
    <section className="opms__sous-section">
      <h4 className="opms__sous-section-titre">Acheteur</h4>
      <OperationAcheteurRecap operation={operation} formData={formData} viewMode={viewMode} errors={errors} setFormData={setFormData} />
    </section>

    <section className="opms__sous-section">
      <h4 className="opms__sous-section-titre">Opération</h4>
      <OperationFormulaireAdmin formData={formData} viewMode={viewMode} errors={errors} setFormData={setFormData} />
    </section>

    <section className="opms__sous-section">
      <h4 className="opms__sous-section-titre">Particularités administratives</h4>
      <OperationParticularites formData={formData} viewMode={viewMode} errors={errors} setFormData={setFormData} />
    </section>
  </div>
);

export default OperationDescriptifAdministratif;
